module.exports = __webpack_public_path__ + "img/PayMethod-iPassMoney.e931ad93.png";